import React from "react";
import { Button, Card, Image, Modal } from "semantic-ui-react";
import { Container, Row, Col } from "react-bootstrap";

function UserCard({
  showModal,
  setShowModal,
  showUpdate,
  setUser,
  deleteUser,
  processing,
}) {
  return (
    <Modal
      open={showModal.show}
      centered
      basic
      dimmer='blurring'
      size='tiny'
      style={{
        position: "relative",
        height: "85vh",
      }}
      closeIcon
      onClose={() => setShowModal({ show: false, data: {} })}
    >
      <Container className='h-100'>
        <Row className=' h-100 align-items-center'>
          <Col>
            {" "}
            <Card centered>
              <Image
                // floated='right'
                size='medium'
                src={`${showModal.data.user?.image || showModal.data.image}`}
              />
              <Card.Content>
                <Card.Header>{`${
                  showModal.data.user?.firstName || showModal.data.firstName
                } ${
                  showModal.data.user?.lastName || showModal.data.lastName
                }`}</Card.Header>
                <Card.Meta>
                  {showModal.data.user
                    ? showModal.data.user?.role
                      ? showModal.data.user?.role
                      : "N/A"
                    : `Level ${showModal.data.level}`}
                </Card.Meta>
              </Card.Content>
              <Card.Content extra>
                <Button
                  icon='edit'
                  primary
                  circular
                  onClick={() => {
                    setUser(
                      showModal.data.user ? showModal.data.user : showModal.data
                    );
                    showUpdate(true);
                    setShowModal({ ...showModal, show: false });
                  }}
                />
                <Button
                  icon='trash'
                  negative
                  circular
                  loading={processing}
                  onClick={() => {
                    setShowModal({ ...showModal, show: false });
                    deleteUser(showModal.data.uuid);
                  }}
                />
              </Card.Content>
            </Card>
          </Col>
        </Row>
      </Container>
    </Modal>
  );
}

export default UserCard;
